import * as t from 'io-ts';
import { authorizedTo, groups, id, meta, role, entityItems, entityFolders } from '@/services/api';
import { withFallback } from 'io-ts-types/withFallback';

const data = t.type({
  name: t.string,
  email: t.string,
  phoneNumber: withFallback(t.string, ''),
  notificationEmail: withFallback(t.string, ''),
  locale: t.string,
  admin: t.boolean,
  role: t.union([role, t.null]),
  permissions: t.array(t.string),
  entityItems,
  entityFolders,
  groups,
  lastLogin: t.union([t.number, t.null]),
});

export const recordCodec = t.type({
  id,
  data,
  authorizedTo,
});

export const listCodec = t.type({
  data: t.array(recordCodec),
  meta,
});

export const detailCodec = t.type({
  data,
  authorizedTo,
});

const requiredFields = t.type({
  name: t.string,
  email: t.string,
  phoneNumber: withFallback(t.string, ''),
  notificationEmail: withFallback(t.string, ''),
  admin: t.boolean,
  permissions: t.array(t.string),
  role: t.union([t.number, t.null]),
  entityItems: t.array(t.number),
  entityFolders: t.array(t.number),
  groups: t.array(t.number),
  invite: t.boolean,
});
const optionalFields = t.partial({
  password: t.union([t.string, t.null]),
});
export const formCodec = t.intersection([requiredFields, optionalFields]);
